import React from 'react'

import style from './style.scss'

type Props = { children: React.ReactNode }

function OrderConfirmationWrapper({ children }: Props) {
  return <div className={style.wrapper}>{children}</div>
}

export default OrderConfirmationWrapper
